import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

/**
 * Layout kỹ thuật cho các link chia sẻ `/la-so/$token`.
 * Điều hướng chính không mở trang hub: bấm "Lá số" dùng menu chọn Tử Vi/Bát Tự.
 */
export const Route = createFileRoute("/la-so")({
  beforeLoad: ({ location }) => {
    if (location.pathname === "/la-so" || location.pathname === "/la-so/") {
      throw redirect({ to: "/tu-vi", replace: true });
    }
  },
  component: LaSoLayout,
});

function LaSoLayout() {
  return <Outlet />;
}
